import { useState } from 'react'
import { MessageCircle, X } from 'lucide-react'
import { API_CONFIG } from '../config/api'

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false)

  // Hard-coded colors to match website theme
  const buttonColor = '#006D77'
  const topbarColor = '#FFFFFF'
  const mainBackgroundColor = '#FFFFFF'
  const secondaryBackgroundColor = '#F7F7E9'

  // Build chat URL with hard-coded colors
  const buildChatUrl = () => {
    const params = new URLSearchParams({
      agency_id: 'mementotravel',
      subdomain: 'www.mementotravelco.co.za',
      franchise_id: API_CONFIG.FRANCHISE_ID,
      topbar_color: topbarColor,
      button_color: buttonColor,
      main_background_color: mainBackgroundColor,
      secondary_background_color: secondaryBackgroundColor,
      custom: 'true'
    })
    
    return `https://acms-frontend-agent-embed-prod-1019535049697.europe-west2.run.app?${params.toString()}`
  }

  const chatUrl = buildChatUrl()

  return (
    <>
      {/* Chat Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          style={{ backgroundColor: buttonColor }}
          className="fixed bottom-6 right-6 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-50 flex items-center gap-2 hover:opacity-90"
          aria-label="Open AI Travel Assistant"
        >
          <MessageCircle size={24} />
          <span className="hidden sm:inline font-medium">AI Travel Assistant</span>
        </button>
      )}

      {/* Chat Window */}
      {isOpen && (
        <div className="fixed bottom-6 right-6 z-50">
          <div className="relative">
            {/* Close Button Overlay */}
            <button
              onClick={() => setIsOpen(false)}
              className="absolute -top-2 -right-2 bg-gray-800 text-white hover:bg-gray-700 rounded-full p-1.5 shadow-lg transition-colors z-10"
              aria-label="Close AI Travel Assistant"
            >
              <X size={18} />
            </button>

            {/* Chat Iframe */}
            <iframe
              src={chatUrl}
              className="w-[420px] h-[560px] sm:w-[420px] sm:h-[580px] border-0 rounded-lg shadow-2xl"
              title="AI Travel Assistant"
              allow="clipboard-write"
            />
          </div>
        </div>
      )}
    </>
  )
}

export default ChatWidget

